import M from '@materializecss/materialize';
import { useCallback, useEffect, useRef } from 'react';
import * as xlsx from 'xlsx';

const UploadModal = ({ isOpen, setIsOpen, setWorkbook }) => {
  const modal = useRef(null);
  const fileInput = useRef(null);

  useEffect(() => {
    const { current } = modal;
    if (current) {
      M.Modal.init(current, {
        onCloseEnd: () => setIsOpen(false),
      });
      return () => {
        if (current) M.Modal.getInstance(current)?.destroy();
      };
    }
  }, [modal, setIsOpen]);

  const getModal = useCallback(
    () => (modal.current ? M.Modal.getInstance(modal.current) : null),
    [modal]
  );
  const open = useCallback(() => getModal()?.open(), [getModal]);
  const close = useCallback(() => getModal()?.close(), [getModal]);

  useEffect(() => {
    isOpen ? open() : close();
  }, [isOpen, close, open]);

  const uploadFile = e => {
    e?.preventDefault();
    const file = fileInput.current.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      const data = new Uint8Array(e.target.result);
      const workbook = xlsx.read(data, {type: 'array'});
      setWorkbook(workbook);
      setIsOpen(false);
    }
    reader.readAsArrayBuffer(file);
  };

  return (
    <div ref={modal} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5 className="center">Upload McKesson File</h5>
          <div className="divider" />
        </div>
        <div className="row">
          <div className="file-field col s12">
            <div>
              <div>
                <input ref={fileInput} type="file" id="file" name="file" />
                <label htmlFor="file">Browse Files</label>
              </div>
              <div className="file-path-wrapper">
                <input id="file-path" className="file-path" type="text" />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m4 offset-m4">
            <a
              href="/"
              className="btn-small blue white-text waves-effect waves-light col s12"
              onClick={uploadFile}
            >
              Upload
            </a>
          </div>
          <div className="col s12 m4">
            <a
              href="/"
              className="btn-small white blue-text waves-effect waves-dark col s12"
              onClick={e => {
                e.preventDefault();
                setIsOpen(false);
              }}
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;
